<div class="pagecontent">
    <h1 class="header1">Upload Documents</h1>
    <div class="document-content" formGroupName="tripRequest">
        @for (date of appointmentDatesFr.controls; track date; let i = $index) {
            <div formArrayName="tripAppointments">   
                <div [formGroupName]="i" >
                    <div class="trip-appointment-date-container">
                        <h2 class="appointment-subheading">Appointment: {{date.get('appointmentDate')?.value | date: 'MM/dd/yyyy' }} 
                                at {{ date.get('appointmentDate')?.value | date: 'shortTime'}}</h2>
                    </div>
                        @for (expense of getAppointmentExpense(i).controls; track expense; let j = $index) {
                            <div formArrayName="tripExpenses">   
                                <div [formGroupName]="j">
                                    <div class="form-field">
                                        <label [for]="'expenseAmount'+i+'-'+j">
                                            {{expense.get('expenseType')?.value === 'Toll' ? 'Toll Expenses' : 'Parking Expenses'}}</label>
                                        <mat-form-field appearance="outline">
                                            <input [id]="'expenseAmount'+i+'-'+j" formControlName="expenseAmount" matInput placeholder="Enter Expense Amount" decimalOnly/>
                                        </mat-form-field>
                                    </div>                                                                      
                                </div>
                            </div>
                        }
                </div>
            </div>
        }
        <div class="document-options" formGroupName="appointmentVerificationDocuments">
            <div class="expense-row">
                <div class="form-field">
                    <label for="appointment_file_select">Appointment Verification 
                        @if(isAppVerificationDocReq) {
                            <span class="star">*</span>
                        }
                    </label>
                    <mat-form-field appearance="outline">
                        <input id="appointment_file_select" matInput [placeholder]="appointmentFileSelectPlaceHolder" readonly 
                                [errorStateMatcher]="matcher" formControlName ="appointmentDocument">
                        @if (hasError(`appointmentVerificationDocuments.appointmentDocument`, 'required')) {
                            <mat-error>This field is required.</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="form-field">                    
                    <button class="browse-button" type="button" matInput mat-button aria-label="Upload appointment verification documents" (click)="appointmentFileSelect()">
                        <div class="button-icon">
                            <mat-icon class="mat-icon-file-upload">file_upload</mat-icon>
                        </div>
                    </button>                
                    <input #appointmentfileUpload
                        type="file" 
                        id="file-upload" 
                        style="display: none;" 
                        multiple 
                        (change)="onFilesSelected($event,'appointment')"
                        accept=".pdf, .txt, image/*, .doc, .docx, .xls, .xlsx, .csv">
                </div>
            </div>
            @if (appVerficationDocumentsDto.length > 0) {
                <div class="file-row">
                    @for (doc of appVerficationDocumentsDto; track $index) {
                        <div class="file-remove">
                            <span class="file-name-span">{{ doc.fileName }}</span>
                            <mat-icon color="warn" (click)="removeFile($index, 'appointment')">close</mat-icon>
                        </div>   
                    } 
                </div>
            }
            @if(linkingDocuments.length > 0){
                <div class="panel-container">
                    <mat-expansion-panel [expanded]="false" #documentsPanel hideToggle class="outer-panel" (opened)="onLinkPanelOpen()">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Link Existing Verification Documents</mat-panel-title>
                            <mat-icon>
                                {{ documentsPanel.expanded ? 'remove' : 'add' }}
                            </mat-icon>
                        </mat-expansion-panel-header>
                        <div class="table-container">
                            <table mat-table [dataSource]="dataSource">
                                <ng-container matColumnDef="confirmationNumber">
                                    <th mat-header-cell *matHeaderCellDef> Confirmation No </th>
                                    <td mat-cell *matCellDef="let element"> {{element.confirmationNumber}} </td>
                                </ng-container>

                                <!-- Name Column -->
                                <ng-container matColumnDef="fileNames">
                                    <th mat-header-cell *matHeaderCellDef> File Names </th>
                                    <td mat-cell *matCellDef="let element"> {{element.fileNames}} </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClick(documentsPanel, row)"></tr>
                            </table>
                            <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[pageSize]" showFirstLastButtons aria-label="Select page of trip requests" [hidePageSize]="true"></mat-paginator>
                        </div>
                    </mat-expansion-panel>
                </div>
            }
             <a role="button" tabindex="0" (click)="downloadVerificationFile()">Download Provider Verification Document</a>
            <h2 class="document-subheading">Looking to submit your Verification another way?</h2>
            <mat-checkbox class="options-checkbox-margin" formControlName="documentUploading" (change)="onAppVerificationSelectionChange($event)">I need help uploading a document</mat-checkbox>
            <mat-checkbox class="options-checkbox-margin" formControlName="documentEmailing" (change)="onAppVerificationSelectionChange($event)">I am emailing the document</mat-checkbox>
            @if (appointmentVerificationDocuments.get('documentEmailing')?.value) {
                <p class="option-information-text">Please email your documents to <span class="option-text">{{tripRequestFormService.consumerCounty.email}}</span></p>
            }
            <mat-checkbox class="options-checkbox-margin" formControlName="documentMailing" (change)="onAppVerificationSelectionChange($event)">I am mailing the document</mat-checkbox>
            @if (appointmentVerificationDocuments.get('documentMailing')?.value) {
                <p class="option-information-text">Note - mailing your documentation may delay payment processing.</p>
                <p class="option-information-text">Please mail your documents to <span class="option-text">{{tripRequestFormService.consumerCounty.mailingAddress}}</span></p>
            }
            <mat-checkbox class="options-checkbox-margin" formControlName="documentFaxing" (change)="onAppVerificationSelectionChange($event)">I am faxing the document</mat-checkbox>
            @if (appointmentVerificationDocuments.get('documentFaxing')?.value) {
                <p class="option-information-text">Please fax your documents to <span class="option-text">{{tripRequestFormService.consumerCounty.faxNo}}</span></p>
            }
        </div>
        @if(showTollSection) {
            <div class="document-options reduced-top-margin" formGroupName="tollDocuments">
                <div class="expense-row">
                    <div class="form-field">
                        <label for="toll_file_select">Toll Receipts
                            @if(isTollDocReq) {
                                <span class="star">*</span>
                            }
                        </label>
                        <mat-form-field appearance="outline">
                            <input id="toll_file_select" matInput [placeholder]="tollFileSelectPlaceHolder" readonly
                                [errorStateMatcher]="matcher" formControlName ="tollDocument">
                            @if (hasError(`tollDocuments.tollDocument`, 'required')) {
                                <mat-error>This field is required.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="form-field">                    
                        <button class="browse-button" type="button" matInput mat-button aria-label="Upload toll receipts" (click)="tollFileSelect()">
                            <div class="button-icon">
                                <mat-icon class="mat-icon-file-upload">file_upload</mat-icon>
                            </div>
                        </button>                
                        <input #tollfileUpload
                            type="file" 
                            id="file-upload" 
                            style="display: none;" 
                            multiple 
                            (change)="onFilesSelected($event, 'Toll')"
                            accept=".pdf, .txt, image/*, .doc, .docx, .xls, .xlsx, .csv">
                    </div>
                </div>
                @if (tollDocumentsDto.length > 0) {
                    <div class="file-row">
                        @for (doc of tollDocumentsDto; track $index) {
                            <div class="file-remove">
                                <span class="file-name-span">{{ doc.fileName }}</span>
                                <mat-icon color="warn" (click)="removeFile($index, 'Toll')">close</mat-icon>
                            </div>   
                        } 
                    </div>
                }
                <h2 class="document-subheading">Looking to submit your expenses another way?</h2>
                <mat-checkbox class="options-checkbox-margin" formControlName="documentUploading" (change)="onTollSelectionChange($event)">I need help uploading a document</mat-checkbox>
                <mat-checkbox class="options-checkbox-margin" formControlName="documentEmailing" (change)="onTollSelectionChange($event)">I am emailing the document</mat-checkbox>
                @if (tollDocuments.get('documentEmailing')?.value) {
                    <p class="option-information-text">Please email your documents to <span class="option-text">{{tripRequestFormService.consumerCounty.email}}</span></p>
                }
                <mat-checkbox class="options-checkbox-margin" formControlName="documentMailing" (change)="onTollSelectionChange($event)">I am mailing the document</mat-checkbox>
                @if (tollDocuments.get('documentMailing')?.value) {
                    <p class="option-information-text">Note - mailing your documentation may delay payment processing.</p>
                    <p class="option-information-text">Please mail your documents to <span class="option-text">{{tripRequestFormService.consumerCounty.mailingAddress}}</span></p>
                }
                <mat-checkbox class="options-checkbox-margin" formControlName="documentFaxing" (change)="onTollSelectionChange($event)">I am faxing the document</mat-checkbox>
                @if (tollDocuments.get('documentFaxing')?.value) {
                    <p class="option-information-text">Please fax your documents to <span class="option-text">{{tripRequestFormService.consumerCounty.faxNo}}</span></p>
                }
            </div>
        }
        @if(showParkingSection) {
            <div class="document-options reduced-top-margin" formGroupName="parkingDocuments">
                <div class="expense-row">
                    <div class="form-field">
                        <label for="parking_file_select">Parking Receipts
                            @if(isParkingDocReq) {
                                <span class="star">*</span>
                            }
                        </label>
                        <mat-form-field appearance="outline">
                            <input id="parking_file_select" matInput [placeholder]="parkingFileSelectPlaceHolder" readonly
                                [errorStateMatcher]="matcher" formControlName ="parkingDocument">
                            @if (hasError(`parkingDocuments.parkingDocument`, 'required')) {
                                <mat-error>This field is required.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="form-field">                    
                        <button class="browse-button" type="button" matInput mat-button aria-label="Upload parking receipts" (click)="parkingFileSelect()">
                            <div class="button-icon">
                                <mat-icon class="mat-icon-file-upload">file_upload</mat-icon>
                            </div>
                        </button>                
                        <input #parkingfileUpload
                            type="file" 
                            id="file-upload" 
                            style="display: none;" 
                            multiple 
                            (change)="onFilesSelected($event, 'Parking')"
                            accept=".pdf, .txt, image/*, .doc, .docx, .xls, .xlsx, .csv">
                    </div>
                </div>
                @if (parkingDocumentsDto.length > 0) {
                    <div class="file-row">
                        @for (doc of parkingDocumentsDto; track $index) {
                            <div class="file-remove">
                                <span class="file-name-span">{{ doc.fileName }}</span>
                                <mat-icon color="warn" (click)="removeFile($index, 'Parking')">close</mat-icon>
                            </div>   
                        } 
                    </div>
                }
                <h2 class="document-subheading">Looking to submit your expenses another way?</h2>
                <mat-checkbox class="options-checkbox-margin" formControlName="documentUploading" (change)="onParkingSelectionChange($event)">I need help uploading a document</mat-checkbox>
                <mat-checkbox class="options-checkbox-margin" formControlName="documentEmailing" (change)="onParkingSelectionChange($event)">I am emailing the document</mat-checkbox>
                @if (parkingDocuments.get('documentEmailing')?.value) {
                    <p class="option-information-text">Please email your documents to <span class="option-text">{{tripRequestFormService.consumerCounty.email}}</span></p>
                }
                <mat-checkbox class="options-checkbox-margin" formControlName="documentMailing" (change)="onParkingSelectionChange($event)">I am mailing the document</mat-checkbox>
                @if (parkingDocuments.get('documentMailing')?.value) {
                    <p class="option-information-text">Note - mailing your documentation may delay payment processing.</p>
                    <p class="option-information-text">Please mail your documents to <span class="option-text">{{tripRequestFormService.consumerCounty.mailingAddress}}</span></p>
                }
                <mat-checkbox class="options-checkbox-margin" formControlName="documentFaxing" (change)="onParkingSelectionChange($event)">I am faxing the document</mat-checkbox>
                @if (parkingDocuments.get('documentFaxing')?.value) {
                    <p class="option-information-text">Please fax your documents to <span class="option-text">{{tripRequestFormService.consumerCounty.faxNo}}</span></p>
                }
            </div>
        }
    </div>
</div>

